import { SkinnableComponent } from '../../../types/component-skin';
import { COMPONENT_TYPES } from '../../../constants';
import BasicBinaryLegsSkin from './skins/BasicBinaryLegsSkin';
import { useBinaryLegsLogic } from './BinaryLegsLogic';

/**
 * 바이너리 레그 컴포넌트 스킨 가능 정의
 */
export const BinaryLegsSkinnable: SkinnableComponent = {
  type: COMPONENT_TYPES.BINARY_LEGS,
  name: '바이너리 레그',
  category: 'mlm',
  options: [], // 나중에 ComponentOption 배열로 구성
  defaultSkin: 'basic',
  internalSkins: {
    basic: BasicBinaryLegsSkin as any // 임시로 any 처리
  },
  useLogic: useBinaryLegsLogic as any, // 임시로 any 처리
  defaultProps: {
    title: '조직도',
    emptyText: '데이터가 없습니다',
    loadingText: '조직도를 불러오는 중입니다...',
    errorText: '데이터를 불러오는데 실패했습니다',
    loginRequiredText: '로그인이 필요한 서비스입니다.',
    showNavigationButtons: true,
    showBreadcrumb: true,
    showDebugMode: false,
    showZoomControls: true,
    showNodePV: true,
    showNodeRank: true,
    showNodeGrade: true,
    showNodePhone: true,
    showNodeCenter: true,
    showNodeGroupPV: true,
    showMoreButton: true,
    initialZoom: 1,
    minZoom: 0.3,
    maxZoom: 2.5,
    lineColor: '#3f51b5',
    nodeBackgroundColor: '#ffffff',
    nodeBorderColor: '#e0e0e0',
    nodeShadow: '0 2px 4px rgba(0,0,0,0.1)',
    titleBackgroundColor: '#3f51b5',
    titleTextColor: '#ffffff',
    contentTextColor: '#333333',
    bubbleBadgeColor: '#2196f3',
    bubbleBadgeTextColor: '#ffffff',
    buttonPrimaryColor: '#3f51b5',
    buttonSecondaryColor: '#6c757d',
    buttonSuccessColor: '#28a745',
    buttonDangerColor: '#dc3545',
    containerBackgroundColor: '#ffffff',
    breadcrumbColor: '#666666',
    breadcrumbActiveColor: '#3f51b5'
  }
};